import React from 'react';
import Lottie from 'lottie-react';
import aiLoaderBlack from '../assets/AI-loader-black.json';
import aiLoaderOrange from '../assets/AI-loader-orange.json';

interface LoadingAnimationProps {
  color?: 'brand' | 'black';
  size?: number;
}

export const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
  color = 'brand',
  size = 20,
}) => {
  const animationData = color === 'brand' ? aiLoaderOrange : aiLoaderBlack;

  return <Lottie animationData={animationData} loop style={{ height: size }} />;
};
